import React from 'react';
import Steps from 'rc-steps';
import Content from '../components/layout/Content';

import Step from '../components/Step';

import gem1 from '../components/img/gem-flexibel.svg';
import gem2 from '../components/img/gem-lagspelare.svg';
import gem3 from '../components/img/gem-driven.svg';
import gem4 from '../components/img/gem-ninja.svg';

import fig1 from '../components/img/floskel-flexibel.svg';
import fig2 from '../components/img/floskel-lagspelare.svg';
import fig3 from '../components/img/floskel-driven.svg';
import fig4 from '../components/img/floskel-ninja.svg';

import goalOn from '../components/img/icon-goal-on.svg';
import goalOff from '../components/img/icon-goal-off.svg';

import iconLock from '../components/img/icon-lock.svg';

const steps = [
  {
    title: 'Flexibel',
    iconProcess: <img alt="" src={fig1} />,
    iconWait: <img alt="" src={iconLock} />,
    iconFinish: <img alt="" src={gem1} />,
    url: '/flexibel/',
  },
  {
    title: 'Lagspelare',
    iconProcess: <img alt="" src={fig2} />,
    iconWait: <img alt="" src={iconLock} />,
    iconFinish: <img alt="" src={gem2} />,
    url: '/lagspelare/',
  },
  {
    title: 'Driven',
    iconProcess: <img alt="" src={fig3} />,
    iconWait: <img alt="" src={iconLock} />,
    iconFinish: <img alt="" src={gem3} />,
    url: '/driven/',
  },
  {
    title: 'Ninja',
    iconProcess: <img alt="" src={fig4} />,
    iconWait: <img alt="" src={iconLock} />,
    iconFinish: <img alt="" src={gem4} />,
    url: '/ninja/',
  },
  {
    title: 'Mål',
    iconProcess: <img alt="" src={goalOn} />,
    iconWait: <img alt="" src={goalOff} />,
    iconFinish: <img alt="" src={goalOn} />,
  },
];

const C = ({ transition }) => (
  <div className="Shell" style={transition && transition.style}>
    <Content header>
      <div className="container">
        <h2 className="Steps__heading">Vad gömmer sig bakom floskeln?</h2>
        <div className="Steps__wrapper">
          <Steps className="Steps" direction="vertical" current={3}>
            {steps.map((s, i) => (
              <Step
                className="Steps__item"
                key={i}
                title={s.title}
                iconWait={s.iconWait}
                iconProcess={s.iconProcess}
                iconFinish={s.iconFinish}
                url={s.url}
              />
            ))}
          </Steps>
        </div>
      </div>
    </Content>
  </div>
);
export default C;



// WEBPACK FOOTER //
// ./src/pages/C.js